module.exports = __webpack_public_path__ + "img/icon-supply-price@2x.cdc04b35.png";